import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { APP_IMPORTS } from './app.imports';
import { APP_PROVIDERS } from './app.providers';

import { AppComponent } from './app.component';

import * as components from './components';
import * as layouts from './layout';
import * as directives from './directives';
import * as pipes from './pipes';

@NgModule({
  declarations: [
    AppComponent,
    ...Object.keys(components)
      .map(key => components[key]),
    ...Object.keys(pipes)
      .map(key => pipes[key]),
    ...Object.keys(directives)
      .map(key => directives[key]),
    ...Object.keys(layouts)
      .filter(key => key !== key.toUpperCase())
      .map(key => layouts[key])
  ],
  imports: [
    APP_IMPORTS,
    IonicModule.forRoot(AppComponent)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    ...Object.keys(layouts)
      .filter(key => key !== key.toUpperCase())
      .map(key => layouts[key])
  ],
  providers: [
    APP_PROVIDERS,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts